import { TERMS_LINKS } from '@avalara/bat-apps-shared/lib/constants';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isFormIncomplete } from '../../lib/shared-signup';
import { selectState, selectIsNonAdmin } from '../../selectors';
import ExternalLink from '../external-link';
import { createNetNewSTRAAccount } from '../../lib/side-effects/accounts';
import { addRiskAssessmentOffer } from '../../lib/side-effects/offers';
const BuyButton = ({ showConnectors }) => {
    const { account: { isLoggedIn, }, data: { marketingData: { connector }, }, order: { discountAdditionalLegalText, }, sharedSignup, } = useSelector(selectState);
    const dispatch = useDispatch();
    const history = useHistory();
    const formIncomplete = isFormIncomplete(sharedSignup);
    const isNonAdmin = useSelector(selectIsNonAdmin);
    const missingConnector = showConnectors && !connector;
    const disabled = formIncomplete || (isLoggedIn && isNonAdmin) || missingConnector;
    const onSubmit = () => {
        const options = {
            history,
            paymentToken: '',
        };
        if (!isLoggedIn) {
            dispatch(createNetNewSTRAAccount(options));
        }
        else {
            dispatch(addRiskAssessmentOffer(options));
        }
    };
    const buyButtonText = 'Claim now';
    return (React.createElement("div", { className: 'pad-top-md' },
        React.createElement("div", { className: 'get-started-button-container' },
            React.createElement("button", { "data-ref": 'buy.risk-assessment.submit-button', id: 'submit-payment', disabled: disabled, onClick: onSubmit, className: 'button primary large buy-now margin-bottom-md' }, buyButtonText)),
        React.createElement("span", { className: 'get-started-text-link' },
            "By clicking ",
            buyButtonText,
            " you accept our",
            ' ',
            React.createElement(ExternalLink, { href: TERMS_LINKS.esow, alwaysOpenInNewTab: true }, 'terms & conditions'),
            React.createElement("br", null),
            "and the",
            ' ',
            React.createElement(ExternalLink, { href: TERMS_LINKS.ps, alwaysOpenInNewTab: true }, 'Avalara Professional Services terms & conditions')),
        discountAdditionalLegalText != null &&
            React.createElement("p", { className: 'margin-top-sm', "data-ref": 'risk-assessment.buy-button.legal-text' }, discountAdditionalLegalText)));
};
export default BuyButton;
